import { ReactElement, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Select from "react-select";
import tools from "../../../utils/tools";

const Specifics = ({ form, setForm, parts, specifics, fetchBrand }) => {
  const [selected, setSelected] = useState<any>(form?.specifics || {});

  const list = () => {
    const rows: ReactElement[] = [];
    specifics?.map((specific, index) => {
      rows.push(
        <div key={index} className="flex">
          <input
            type="checkbox"
            defaultChecked={form?.specifics[specific.slug]?.isAttribute}
            onChange={(input) => {
              const data = form?.specifics[specific.slug] || {};
              data.isAttribute = input.target.checked;
              setSelected((prevState) => ({
                ...prevState,
                [specific.slug]: data,
              }));
            }}
          />
          <label>شاخص</label>
          <input
            type="checkbox"
            defaultChecked={form?.specifics[specific.slug]?.inTitle}
            onChange={(input) => {
              const data = form?.specifics[specific.slug] || {};
              data.inTitle = input.target.checked;
              setSelected((prevState) => ({
                ...prevState,
                [specific.slug]: data,
              }));
              // if (data.value) {
              //   setTitle(prevState => ({...prevState, [specific.slug]: specific.specificValues.find(e => e.slug == data.value)?.title}))
              // }
            }}
          />
          <label>نمایش در عنوان</label>
          <select
            className="selector"
            defaultValue={form?.specifics[specific.slug]?.value}
            onChange={(input) => {
              const data = form?.specifics[specific.slug] || {};
              data.value = input.target.value;
              setSelected((prevState) => ({
                ...prevState,
                [specific.slug]: data,
              }));
            }}
          >
            <option value="">انتخاب کنید</option>
            {specific.specificValues?.map((e) => (
              <option value={e.slug}>{e.title}</option>
            ))}
          </select>
          <label>{specific?.title}</label>
          <input
            className="selector"
            onChange={(input) => {
              const data = form?.specifics[specific.slug] || {};
              data.sort = input.target.value;
              setSelected((prevState) => ({
                ...prevState,
                [specific.slug]: data,
              }));
            }}
            value={form?.specifics[specific.slug]?.sort}
          />
          <label>ترتیب</label>
        </div>,
      );
    });

    return rows;
  };

  useEffect(() => {
    setForm((prev) => ({
      ...prev,
      specifics: selected,
    }));
  }, [selected]);

  return (
    <div className="AddInfoContainer">
      <label>نوع کالا</label>
      <Select
        options={tools.selectFormatter(parts, "id", "title", "انتخاب کنید")}
        value={tools.selectFormatter(
          parts.filter((e) => e.id == form.partId),
          "id",
          "title",
        )}
        className="width100"
        onChange={(selected) => {
          fetchBrand(selected.value.toString());
          setForm((prev) => ({
            ...prev,
            partId: selected.value.toString(),
          }));
        }}
      />
      {list()}
    </div>
  );
};

export default Specifics;
